export const storedPermissions = JSON.parse(
  localStorage.getItem("user_permission") ?? "[]",
);
